import { useState, useEffect } from 'react';
import { sendNotification, requestNotificationPermission } from '../utils/notifications';

export const useAutoReminders = (appointments) => {
  const [pendingReminders, setPendingReminders] = useState([]);
  
  useEffect(() => {
    // Load auto-reminder settings
    const settings = JSON.parse(localStorage.getItem('autoReminders') || '{"enabled24h": true, "time24h": "21:00", "enabled12h": false, "enabledSameDay": true, "timeSameDay": "09:00"}');
    
    const checkReminders = () => {
      const now = new Date();
      const currentTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
      const today = now.toISOString().split('T')[0];
      
      const pending = [];
      
      appointments.forEach(apt => {
        const aptDate = new Date(apt.date + 'T12:00:00');
        const diffMs = aptDate.getTime() - now.getTime();
        const diffHours = diffMs / (1000 * 60 * 60);
        const diffDays = Math.floor(diffHours / 24);
        
        // Check 24h before
        if (settings.enabled24h && diffDays === 1 && currentTime === settings.time24h) {
          pending.push({...apt, reminderType: '24h'});
        }
        
        // Check 12h before
        if (settings.enabled12h && diffHours >= 11.5 && diffHours <= 12.5) {
          pending.push({...apt, reminderType: '12h'});
        }
        
        // Check same day
        if (settings.enabledSameDay && apt.date === today && currentTime === settings.timeSameDay) {
          pending.push({...apt, reminderType: 'sameDay'});
        }
      });
      
      if (pending.length > 0) {
        setPendingReminders(pending);
        
        // Send browser notification
        requestNotificationPermission().then(granted => {
          if (granted) {
            sendNotification('⏰ Recordatorios Pendientes', {
              body: `Tienes ${pending.length} recordatorio(s) para enviar`,
              icon: '/favicon.ico',
              tag: 'pending-reminders'
            });
          }
        });
      }
    };
    
    // Check every minute
    const interval = setInterval(checkReminders, 60000);
    checkReminders(); // Check immediately
    
    return () => clearInterval(interval);
  }, [appointments]);
  
  return { pendingReminders, clearPendingReminders: () => setPendingReminders([]) };
};
